import { Button, Grid, IconButton, TextField, Tooltip } from '@material-ui/core';
import React, { Component } from 'react';
import { SearchTwoTone, HighlightOffTwoTone } from '@material-ui/icons';

export default class FilterBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search_string: "",
            searching: false,
            input_error: false,
            filter_applied: false,
            input_label: 'Surname',
            filter_opened: false,
            filter_type: "name"
        }
    }

    componentDidMount = () => {
      if (this.props.filter_applied){
        this.setState({
            filter_applied:true,
            filter_opened:true,
            filter_type:this.props.filter_obj.type,
            input_label: this.props.filter_obj.type==='name'? 'Surname' : 'Employee #',
            search_string:this.props.filter_obj.search_string
        });
      }
    };
        
    sendUpFilter = () => {
        if (!this.state.filter_applied){
            if (!this.state.search_string) {return;}

            this.props.setParentFilter({type:this.state.filter_type,search_string:this.state.search_string});
            this.setState({filter_applied:true, input_error:false});

        } else {
            this.setState({search_string:"",searching:false, search_error:"",filter_applied:false, input_label: "Surname", filter_type:'name', filter_opened:false});
            this.props.setParentFilter({type:'clear',search_string:""});
        }
    }

    openFilterBox = (filter_type) => {
        let input_lable = "Surname"
        switch (filter_type) {
            case 'number':
                input_lable = "Employee #"
                break;
            case 'rom':
                input_lable = "Manager Code"
                break;
            case 'cycle':
                input_lable = "Cycle Code"
                break;
            case 'branch':
                input_lable = "Branch Code"
                break;
        
            default:
                break;
        }
        this.setState({filter_opened:true,filter_type:filter_type, input_label: input_lable});
    }
    

    render() {return (
        <Grid
            container
            alignItems='center'
            style={{
                // backgroundColor:'yellow',
                // width:'175px',
                marginBottom:'5px',
                marginTop:'5px',
                marginLeft:'5px',
            }}
        >
            
            {(!this.state.filter_opened||!this.props.data_populated)&&
            <div style={{display:'flex', justifyContent:'flex-end', alignItems:'center', width:'100%'}}>

                {!this.props.hide_name_filter&&
                <Tooltip title={"Search and Filter by Employee Name"}>
                <span>
                <Button
                    variant='contained'
                    startIcon={<SearchTwoTone/>}
                    size='small'
                    disabled={!this.props.data_populated}
                    onClick={()=>this.openFilterBox('name')}
                    style={{marginLeft:5}}
                >
                    name
                </Button>
                </span>
                </Tooltip>}
                
                
                {!this.props.hide_emp_num_filter&&
                <Tooltip title={"Search and Filter by Employee Number"}>
                <span>
                <Button
                    variant='contained'
                    startIcon={<SearchTwoTone/>}
                    size='small'
                    disabled={!this.props.data_populated}
                    onClick={()=>this.openFilterBox('number')}
                    style={{marginLeft:5}}
                >
                    emp.&nbsp;#
                </Button>
                </span>
                </Tooltip>}

                {this.props.show_hod_filter&&
                <Tooltip title={"Search and Filter by Manager Code"}>
                <span>
                <Button
                    variant='contained'
                    startIcon={<SearchTwoTone/>}
                    size='small'
                    disabled={!this.props.data_populated}
                    onClick={()=>this.openFilterBox('rom')}
                    style={{marginLeft:5}}
                >
                    Manager
                </Button>
                </span>
                </Tooltip>}
               
                {this.props.show_cycle_filter&&
                <Tooltip title={"Search and Filter by cycle Code"}>
                <span>
                <Button
                    variant='contained'
                    startIcon={<SearchTwoTone/>}
                    size='small'
                    disabled={!this.props.data_populated}
                    onClick={()=>this.openFilterBox('cycle')}
                    style={{marginLeft:5}}
                >
                    Cycle
                </Button>
                </span>
                </Tooltip>}
               
                {this.props.show_branch_filter&&
                <Tooltip title={"Search and Filter by Branch Code"}>
                <span>
                <Button
                    variant='contained'
                    startIcon={<SearchTwoTone/>}
                    size='small'
                    disabled={!this.props.data_populated}
                    onClick={()=>this.openFilterBox('branch')}
                    style={{marginLeft:5}}
                >
                    Branch
                </Button>
                </span>
                </Tooltip>}

            </div>}

            {this.state.filter_opened&&this.props.data_populated&&
            <div style={{display:"flex", justifyContent:'center', alignItems:'center', width:'100%'}}>

                <TextField
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    autoFocus={true}
                    label={this.state.input_label}
                    variant='outlined'
                    value={this.state.search_string}
                    onChange={(e) => {
                        const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                        // const can_sub = (outText.length>2);
                        this.setState({search_string: outText});
                    }}
                    // required
                    style={{width:'150px', marginTop:'10px'}}
                    disabled={this.state.filter_applied}
                    error={this.state.input_error}
                />
                &nbsp;&nbsp;
                <div>
                    <Tooltip title={this.state.filter_applied? "Clear Filter" : "Search and Filter"}>
                    <span>
                        <IconButton
                            onClick={this.sendUpFilter} 
                            variant='contained'
                            disabled={!this.props.data_populated}
                            // style={{height:'100%', width:'20px'}}
                        >

                            {!this.state.filter_applied&&
                            <SearchTwoTone/>}

                            {this.state.filter_applied&&
                            <HighlightOffTwoTone/>}

                        </IconButton>
                    </span>
                    </Tooltip>

                    {!this.state.filter_applied&&            
                    <Tooltip title={"Cancel"}>
                    <span>
                        <IconButton
                            onClick={()=>this.setState({filter_opened:false,search_string:"",search_error:"",filter_applied:false})} 
                            variant='contained'
                            // disabled={!this.props.data_populated}
                            // style={{height:'100%', width:'20px'}}
                        >

                            <HighlightOffTwoTone/>

                        </IconButton>
                    </span>
                    </Tooltip>}
                    
                </div>

            </div>}


        </Grid>
    );}
}
